import { render, staticRenderFns } from "./SpecUpdates.vue?vue&type=template&id=601c5794&scoped=true"
import script from "./SpecUpdates.vue?vue&type=script&lang=js"
export * from "./SpecUpdates.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "601c5794",
  null
  
)

export default component.exports